// extracted by mini-css-extract-plugin
export var buttonCommons = "styles-module--button-commons--Kmc7g";
export var buttonPrimary = "styles-module--button-primary--q0A2n";
export var buttonSecondary = "styles-module--button-secondary--hWq-F";
export var buttonTernary = "styles-module--button-ternary--j41j4";
export var buttonGhost = "styles-module--button-ghost--Rj+nM";
export var buttonGhostSecondary = "styles-module--button-ghost-secondary--oJQGH";
export var buttonSimple = "styles-module--button-simple--95Pgv";